import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const contactPageK = {
  contactNumber: "contact_page.contactNumber",
  writeToUs: "contact_page.writeToUs",
  callUs: "contact_page.callUs",
  mail: "contact_page.mail",
  contactDeko: "contact_page.contactDeko",
  contactPerson: "contact_page.contactPerson",
  yourContacts: "contact_page.yourContacts",
  customerSupport: "contact_page.customerSupport",
  contact: "contact_page.contact",
};

export const useContactPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      contactNumber: t(contactPageK.contactNumber),
      writeToUs: t(contactPageK.writeToUs),
      callUs: t(contactPageK.callUs),
      mail: t(contactPageK.mail),
      contactDeko: t(contactPageK.contactDeko),
      contactPerson: t(contactPageK.contactPerson),
      yourContacts: t(contactPageK.yourContacts),
      customerSupport: t(contactPageK.customerSupport),
      contact: t(contactPageK.contact),
    }),
    [i18n.language]
  );
};